import { pathMap } from '@/navigation/paths';
import { Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const EditExerciseButton = (props: { exerciseId: string }) => {
  const navigate = useNavigate();
  const { exerciseId } = props;

  return (
    <Tooltip title="Edit Exercise">
      <IconButton
        onClick={(e) => {
          navigate(`${pathMap.EditExercise}/${exerciseId}`);
          e.stopPropagation();
        }}
      >
        <Edit />
      </IconButton>
    </Tooltip>
  );
};
